import { render, staticRenderFns } from "./AiMywork.vue?vue&type=template&id=72853d8a"
import script from "./AiMywork.vue?vue&type=script&lang=js"
export * from "./AiMywork.vue?vue&type=script&lang=js"
import style0 from "./AiMywork.vue?vue&type=style&index=0&id=72853d8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports